import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { MfaVerifyForm } from '@/components/auth/MfaVerifyForm'

export function MfaVerifyPage() {
  const { user, isMfaRequired, isLoading } = useAuth()

  // If not authenticated, redirect to login
  if (!isLoading && !user) {
    return <Navigate to="/login" replace />
  }

  // If MFA not required, redirect to dashboard
  if (!isLoading && user && !isMfaRequired) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="absolute inset-0 bg-gradient-to-br from-dextoro/5 via-transparent to-transparent" />
      <div className="relative z-10">
        <MfaVerifyForm />
      </div>
    </div>
  )
}
